module.exports = {
	"hashVersion": 3,
	"socket": {
		"autoConnect": true,
		"autoReconnect": true
	},
	"businessUrl": "https://business.whispeer.de",
	"salesUrl": "/sales",
	"serviceWorker": {
		"enabled": false
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/conf/base.config.json
// module id = 1IZJ
// module chunks = 1 2 3 4 5 6 7